<div class="py-0.5 px-1 border rounded-md min-w-[80px] flex items-center justify-center" [class]="colorVariants[color]">
  {{statusName}}
</div>
